
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 196.94 213.97"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M174.18 78.79C167.24 70.64 151.29 57.19 151 47c-.27-8.91 4.21-17.07 5-22.25h5.76a10.53 10.53 0 0010.54-10.54v-3.67A10.54 10.54 0 00161.71 0H35.23a10.54 10.54 0 00-10.54 10.54v3.65a10.53 10.53 0 0010.54 10.54H41c.75 5.18 5.23 13.34 5 22.25-.3 10.21-16.25 23.66-23.19 31.81C5.1 99.55.39 116.89 0 132.45c-.44 18.33 8.19 51.17 23.3 64C39.36 210 72.67 214 98.47 214s59.11-4 75.15-17.56c15.11-12.79 23.74-45.63 23.3-64-.37-15.55-5.08-32.89-22.74-53.65zM42.33 114.62a4.28 4.28 0 013.45-2.9l33.76-4.91 15.1-30.59a4.27 4.27 0 017.66 0l15.1 30.59 33.76 4.91a4.27 4.27 0 012.36 7.29l-24.42 23.81 5.76 33.62a4.27 4.27 0 01-6.2 4.5l-30.19-15.87-30.19 15.87a4.27 4.27 0 01-6.2-4.5l5.76-33.62L43.41 119a4.3 4.3 0 01-1.08-4.38zm-30.5 10.74c0-10.29 5.27-18.64 11.76-18.64s11.75 8.35 11.75 18.64S30.08 144 23.59 144s-11.76-8.34-11.76-18.64zm163.42 28.69c-22.71 34.8-33 36.8-67.25 43.43-2.62.5-5.38 1-8.31 1.62a8.42 8.42 0 01-1.22.08 8.33 8.33 0 01-1.22-.08c-2.93-.58-5.69-1.12-8.31-1.62-34.21-6.63-44.54-8.63-67.25-43.43a4.27 4.27 0 117.16-4.67c20.73 31.77 28.6 33.29 61.72 39.71 2.54.49 5.06 1 7.9 1.54 2.84-.57 5.36-1 7.9-1.54 33.12-6.42 41-7.94 61.72-39.71a4.27 4.27 0 117.16 4.67zm-1.9-10c-6.49 0-11.75-8.35-11.75-18.65s5.26-18.64 11.75-18.64 11.76 8.35 11.76 18.64-5.27 18.6-11.76 18.6z","fill":"#5e3717"}})])
          )
        }
      }
    